/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_AnalyticsInputs */

const en_mk_mx_analytics = /** @type {(inputs: Mk_Mx_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage & cost analytics`)
};

const id_mk_mx_analytics = /** @type {(inputs: Mk_Mx_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analitik pemakaian & biaya`)
};

/**
* | output |
* | --- |
* | "Usage & cost analytics" |
*
* @param {Mk_Mx_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_analytics = /** @type {((inputs?: Mk_Mx_AnalyticsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_AnalyticsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_analytics(inputs)
	return en_mk_mx_analytics(inputs)
});